// 1. 基础库
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// Element UI 主题色统一覆盖：primary #409eff → #4A5FF3（必须紧跟 theme-chalk 之后，保证级联顺序）
import '@/styles/element-primary.css'
import 'font-awesome/css/font-awesome.min.css'
import App from './App.vue'
// 提前全局引入 cc-filter-box 样式，避免首次进入时的样式闪烁
import '@/components/common/filter-box/index.scss'

// 1.1 vconsole 移动端调试
// import VConsole from 'vconsole'

// 判断是否为移动端浏览器
function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
}

// // 如果是移动端，启用 vconsole
// if (isMobile() && window.location.href.includes('eiip.hdt.cosmoplat.com')) {
//   new VConsole()
// }
// 替换原来的 vconsole 写法
if (isMobile() && window.location.href.includes('eiip.hdt.cosmoplat.com')) {
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole()
  })
}

// 1.2 i18n 国际化
import i18n from '@/i18n'

// 2. Vuex store（必须早于权限/配置模块加载）
import store from './store'

// 3. 路由（可能依赖 store 中的配置）
import router from './router'

// 4. 微前端框架
import microApp from '@micro-zoe/micro-app'
import { removeDomScope } from '@micro-zoe/micro-app'

// 5. 工具与插件
import Bus from '@/utils/eventBus.js'
import 'zone.js'
import '@/components/common/select/components/select-user/index'

// 6. 自定义工具方法
import { getLoginConfigApi } from '@/utils/config.js'
import watermark from './directives/watermark'
// JSON 卡片校验修复器（引入即启用；不需要时删除该行，渲染逻辑自动回退）
import '@/utils/jsonCardChecker'

// 7. 全局配置
Vue.config.productionTip = false
Vue.use(Bus)
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })
Vue.directive('watermark', watermark)
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 1500 }

// 8. 微前端设置
removeDomScope(true)

// 9. 路由异常处理
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    window.location.reload()
  } else {
    console.error('路由加载失败:', error)
  }
})

// 10. 初始化流程：先获取配置 -> 再挂载应用
// Load login config and permission module in parallel to shorten first-screen wait
const loadPermission = import('./permission').catch((err) => {
  console.error('Load permission module failed:', err)
})

Promise.all([getLoginConfigApi(), loadPermission])
  .then(() => {
    // Start micro frontend
    microApp.start({ 'disable-memory-router': true })
    // Create the Vue instance last, after all pre-requisite modules are loaded
    new Vue({
      store,
      router,
      i18n,
      render: (h) => h(App)
    }).$mount('#base-app')
  })
  .catch((err) => {
    console.error('系统初始化失败:', err)
    // Message.error('系统初始化失败，请刷新重试')
  })
